define('calendarRouter',[
  'app',
  'require',
  'module',
  'marionette',
  'underscore',
  'itemPagesNameMixin'
], function (
  App,
  require,
  module,
  Marionette,
  _,
  ItemPagesNameMixin
) {
  'use strict';

  var CalendarRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'calendar': 'showCalendar'
    }
  });

  var API = {
    showCalendar: function () {
      require([
        'calendarView',
        'contentShowController'
      ], function (CalendarView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          var view = new CalendarView();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.CALENDAR);
        });
      });
    }
  };

  App.on('before:start', function () {
    new CalendarRouter({
      controller: API
    });
  });

  module.exports = CalendarRouter;
});

